(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.dlaCard = {
    attach: function attach(context, settings) {

      $(".dla-card-wrapper-hor").each(function () {
        $(this).find('.card-compress').removeClass('d-none');
        $(this).find('.card-expand').click(function() {
          let nid = $(this).data("nid");
          // $('.dla-card-wrapper-vert[data-nid="'+ nid +'"]').removeClass('d-none').find('.card').addClass('float-right').css("width", "300px").find('.card-compress').removeClass('d-none');
          $('.dla-card-wrapper-vert[data-nid="'+ nid +'"]').removeClass('d-none').find('.card').addClass('float-right').find('.card-compress').removeClass('d-none');
          $('.dla-card-wrapper-hor[data-nid="'+ nid +'"]').removeClass('d-block').addClass('d-none');
        });
      });

      $(".dla-card-wrapper-vert").each(function () {
        $(this).find('.card-compress').click(function() {
          let nid = $(this).data("nid");
          // $('.dla-card-wrapper-vert[data-nid="'+ nid +'"]').addClass('d-none').find('.card').removeClass('float-right').css("width", "300px");
          $('.dla-card-wrapper-vert[data-nid="'+ nid +'"]').addClass('d-none').find('.card').removeClass('float-right');
          $('.dla-card-wrapper-hor[data-nid="'+ nid +'"]').removeClass('d-block').removeClass('d-none');
        });
      });

    }
  };
})(jQuery, Drupal);
